import { CloudOff, RefreshCw } from 'lucide-react';
import { useReseau } from '../lib/reseau.tsx';

/* L'indicateur de réseau.
 *
 * ── Trois états, dont deux seulement s'affichent ────────────────────────────
 *
 *   * tout est porté et le réseau répond : RIEN. C'est le cas ordinaire, et un
 *     badge vert permanent finirait par ne plus être lu — pire, il occuperait
 *     la place au moment où quelque chose d'important doit s'y afficher ;
 *   * des écritures attendent : leur nombre, avec la flèche qui tourne ;
 *   * pas de réseau : le nuage barré, et le nombre s'il y a de quoi.
 *
 * ── Pourquoi si petit ───────────────────────────────────────────────────────
 *
 * L'information utile tient en un mot : « c'est enregistré, ça partira ». Un
 * bandeau qui l'annoncerait en toutes lettres pousserait l'écran vers le bas à
 * chaque creux de couverture — c'est-à-dire à chaque trou — et déplacerait les
 * boutons sous le pouce. La pastille se loge dans l'en-tête, à taille fixe.
 *
 * Elle ne prétend jamais qu'il y a un problème : hors ligne n'est pas une
 * panne, c'est l'état normal d'un parcours. Le libellé dit ce qui est fait,
 * pas ce qui manque.
 */
export function EtatReseau() {
    const { enLigne, enAttente, envoiEnCours } = useReseau();

    if (enLigne && enAttente === 0) return null;

    const titre = !enLigne
        ? (enAttente > 0
            ? `Hors ligne — ${enAttente} écriture${enAttente > 1 ? 's' : ''} gardée${enAttente > 1 ? 's' : ''} ici, elles partiront au retour du réseau`
            : 'Hors ligne — tout est enregistré sur le téléphone')
        : `Envoi en cours — ${enAttente} écriture${enAttente > 1 ? 's' : ''}`;

    return (
        <span
            role="status"
            aria-label={titre}
            title={titre}
            className="flex shrink-0 items-center gap-1 rounded-field px-1.5 py-1 text-[11px] font-bold tabular-nums"
            style={!enLigne
                ? { background: 'var(--brique)', color: 'var(--brique-encre)' }
                : { background: 'var(--tuile)', color: 'var(--tuile-encre)' }}
        >
            {!enLigne
                ? <CloudOff size={14} aria-hidden="true" />
                : (
                    <RefreshCw size={14} aria-hidden="true"
                        className={envoiEnCours ? 'animate-spin' : ''} />
                )}
            {enAttente > 0 && enAttente}
        </span>
    );
}
